import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { parse, format, formatISO, parseISO } from 'date-fns';
import { WtFocusableDirective } from '../directives/wt-focusable.directive';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'wt-date-input',
  template: `<input
    type="text"
    class="form-control"
    placeholder="Please enter as MM/DD/YYYY"
    wtFocusable
    mask="00/00/0000"
    (blur)="onInputBlur()"
    [disabled]="disabled"
    [(ngModel)]="value"
  />`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WtDateInputComponent),
      multi: true,
    },
  ],
  imports: [NgxMaskDirective, ReactiveFormsModule, WtFocusableDirective, FormsModule],
})
export class WtDateInputComponent implements ControlValueAccessor {
  value: string;
  disabled = false;

  private onChange?: (val: string) => void;
  private onTouched?: () => void;

  writeValue(obj: string): void {
    this.value = toDisplay(obj);
  }

  registerOnChange(fn: (val: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputBlur() {
    if (this.onTouched) {
      this.onTouched();
    }

    const val = fromDisplay(this.value);

    if (this.value && !val) {
      this.value = '';
    }

    if (this.onChange) {
      this.onChange(val);
    }
  }
}

function toDisplay(internalVal: string): string {
  if (!internalVal) {
    return '';
  }

  const parsed = parseISO(internalVal);
  return format(parsed, 'MM/dd/yyyy');
}

function fromDisplay(displayVal: string): string {
  try {
    const parsed = parse(displayVal, 'MMddyyyy', new Date());
    return formatISO(parsed, { representation: 'date' });
  } catch (e) {
    if (e instanceof RangeError) {
      return '';
    }

    throw e;
  }
}
